module.exports = __webpack_public_path__ + "img/type--4-spans--single-lang--pt.d49754ca.jpg";